<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17BgSWb/tc-custom/9781504057783.jpg?1700958272370" alt="This image is the cover for the book Lynet: Under Camelot's Banner, The Queens of Camelot"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lynet: Under Camelot's Banner, The Queens of Camelot
      </h1>
      <p class="bookDescription body article font2">
        <b>A maiden fights to bring peace to Arthurian England in this romantic fantasy from an award-winning author.</b><br/>  <br/> Love finds a way in this epic series featuring swords, sorcery, and the women of Camelot.<br/>  <br/> The daughter of the steward of Cambryn, Lynet has seen the damage that following one’s heart can do. Now the threat of war looms over her land. Desperately searching for a way to restore peace to her home and honor to her family, Lynet and her sister decide that Lynet will seek the help of the last heir to the ancient royal house of Cambryn: the High Queen Guinevere.<br/>  <br/> In Camelot, Gareth, squire of Sir Lancelot, is filled with pride and swagger. But when a potential war calls Queen Guinevere to Cambryn, Gareth finds himself in the company of a young woman who has no patience for his shows of bravado, and for the first time in his life Gareth finds himself with something real to prove.<br/>  <br/> The love growing between Gareth and Lynet is undeniable, but so is the danger into which they are drawn. Only if they come to terms with their pasts and learn to trust again will they be able to overcome the festering darkness threatening to consume them both.<br/>  <br/><b>Praise for the Queens of Camelot series</b><br/> “High fantasy at its best.” —<i>SFF</i> on <i>Lynet: Under Camelot’s Banner</i><br/>  <br/> “This novel delivers passion, danger, and excitement laced with fantasy.” —<i>RT Book Reviews </i>on <i>Risa: In Camelot’s Shadow</i><br/>  <br/> “A spellbinding journey.” —BookLoons Reviews on <i>Elen: For Camelot’s Honor</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Zettel
      </h2>
      
      <p class="authorDescription body article">Sarah Zettel is the critically acclaimed author of more than twenty novels, spanning the full range of genre fiction. Her debut novel, <i>Reclamation</i>, won the Locus Award for Best First Novel. Her second release, <i>Fool&rsquo;s War</i>, was a 1997 New York Times Notable Book, and the American Library Association named <i>Playing God</i> one of the Best Books for Young Adults of 1999. Her novel <i>Bitter Angels</i> won the Philip K. Dick Award for best science fiction paperback in 2009. Her latest novel, <i>Dust Girl</i>, was named as one of the best young adult books of the year by both <i>Kirkus Reviews</i> and the American Library Association. Zettel lives in Michigan with her husband, her rapidly growing son, and her cat, Buffy the Vermin Slayer.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8c1d49da